import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-red-alert',
  template: `
    <alert type="danger mb-0" [dismissible]="true" (onClosed)="onClosed()">
      Revisa que hayas respondido correctamente <strong>TODAS</strong> las preguntas de la sección "Cuéntanos sobre ti"
    </alert>
  `,
  styles: []
})
export class RedAlertComponent {

  constructor(public modalRef: BsModalRef) { }

  onClosed(): void {
    this.modalRef.hide();
  }

}
